import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'fury-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LayoutComponent implements OnInit {

  constructor() {
    // This is intentional
  }

  ngOnInit() {
    // This is intentional
  }

  onActivate(e, scrollContainer) {
    scrollContainer.scrollTop = 0;
  }
}
